import ActivateAccount from "pages/auth/ActivateAccount";
import ForgotPassword from "pages/auth/ForgotPassword";
import Page404 from "pages/auth/Page404";
import Page500 from "pages/auth/Page500";
import ResetPassword from "pages/auth/ResetPassword";
import SignIn from "pages/auth/SignIn";
import SignUp from "pages/auth/SignUp";
import React from "react";

export default [
  {
    path: "activate/:token",
    element: <ActivateAccount />,
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "sign-in",
    element: <SignIn />,
  },
  {
    path: "sign-up",
    element: <SignUp />,
  },
  {
    path: "404",
    element: <Page404 />,
  },
  {
    path: "500",
    element: <Page500 />,
  },
];
